import Header, { HeaderLeft } from "../../../layout/Header/Header";
import CommonHeaderRight from "./CommonHeaderRight";

const AccountHeadsHeader = () => {
  return (
    <Header>
      <HeaderLeft>
        <div>
          <div className="fw-bold fs-6 mb-0">Account Heads</div>
          <div className="text-muted">
            <small>
              Configure chart of accounts for the flat.
            </small>
          </div>
        </div>
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default AccountHeadsHeader;
